import { render } from "./KobiRectangle.vue?vue&type=template&id=b80e2af4"
import script from "./KobiRectangle.vue?vue&type=script&lang=js"
export * from "./KobiRectangle.vue?vue&type=script&lang=js"

import "./KobiRectangle.vue?vue&type=style&index=0&id=b80e2af4&lang=css"
script.render = render

export default script